/**
 * Объект с фильтрами, в которых применяли поисковую строку.
 * @type {*|number}
 */
export const activeSearchFilterState = (window.app && window.app.activeSearchState) || {}
